import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/app/[locale]/bestelzuil/KioskPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpertiseStatsSection"] */ "/tmp/8de76d586546b63/components/sections/ExpertiseStatsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/components/sections/KioskCaseStudy.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/components/sections/KioskLocations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskShowcase"] */ "/tmp/8de76d586546b63/components/sections/KioskShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionComparison"] */ "/tmp/8de76d586546b63/components/sections/SolutionComparison.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VenuesSlider"] */ "/tmp/8de76d586546b63/components/sections/VenuesSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BenefitCard"] */ "/tmp/8de76d586546b63/components/ui/BenefitCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de76d586546b63/components/ui/LazyVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingFactorCard"] */ "/tmp/8de76d586546b63/components/ui/PricingFactorCard.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
